import { InjectionToken } from '@angular/core';

export const GLOBAL_CONSTANT = new InjectionToken('GLOBAL_CONSTANT');
